import HTTP from '../utils/http'
import LogProvider from '../classes/log-provider'
import TaskPool from '../classes/task-pool'
import { uniqueString } from '../utils/string'

const _url = uniqueString('ElasticSearchProvider_url')
const _httpPool = uniqueString('ElasticSearchProvider_httpPool')
const _meta = uniqueString('ElasticSearchProvider_meta')

const ES_ENDPOINT = '/pws/v0/fly/tag/batch'

export default class ElasticSearchProvider extends LogProvider {
  static get is() {
    return 'ElasticSearchProvider'
  }

  constructor(config) {
    super(config)

    this[_url] = config.elasticSearchUrl || ES_ENDPOINT
    this[_httpPool] = new TaskPool()
    this[_meta] = config.batchMeta
  }

  onBatch(batch, meta) {
    return HTTP({
      url: this[_url],
      data: this._createRequest(batch),
      beacon: meta.manual,
    })
  }

  _createRequest(logs) {
    const request = {
      tags: logs.map((log) => ({
        data: log.serialize(),
      })),
      timestamp: new Date(),
    }
    let meta = this[_meta]

    meta = typeof meta === 'function' ? meta() : meta

    if (meta) {
      return { ...request, ...meta }
    }
    return request
  }
}
